import React, { useCallback, useEffect, useState } from 'react';

type OwnProps = React.PropsWithChildren<{
  name?: string;
  observeRef: any;
  onVisible: () => void;
  onRender?: () => void;
}>;

export default function ObservableTile({
  children,
  observeRef,
  onVisible,
  name,
  onRender
}: OwnProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [hasReportedVisible, setHasReportedVisible] = useState(false);

  const handleOnVisible = useCallback(() => {
    if (onVisible) {
      onVisible();
      setHasReportedVisible(true);
    }
  }, [onVisible]);

  useEffect(() => {
    if (isVisible && !hasReportedVisible) {
      handleOnVisible();
    }
  }, [isVisible, hasReportedVisible, handleOnVisible]);

  useEffect(() => {
    if (onRender) onRender();
  }, [onRender]);

  const callback: IntersectionObserverCallback = ([entry]) => {
    setIsVisible(entry.intersectionRatio >= 0.5);
  };

  useEffect(() => {
    const options = {
      rootMargin: '0px',
      threshold: 0.5
    };

    observeRef.current = new IntersectionObserver(callback, options);

    if (observeRef.current && name) {
      const node =
        document.querySelector(`#${name}`) ||
        document.querySelector(`#${name.toLowerCase()}`);
      if (node) {
        observeRef.current.observe(node);
      }
    }

    return () => {
      observeRef?.current.disconnect();
    };
  }, [observeRef, name]);

  return <>{children}</>;
}
